import React, { createContext } from "react";
import { Constants } from "./Models/Constants";

export const UserContext = createContext({
    currentUser: Constants.defaultUserContext,
    setCurrentUser: (_: any) => {},
});

export const SiteContext = createContext({
    currentSite: Constants.defaultSiteContext,
    setCurrentSite: (_: any) => {},
});

export const ToastContext = createContext({
    toast: null,
    setToast: () => {}
});

export type ChangesContextType = {
    hasChanges: boolean;
    setHasChanges: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ChangesContext = createContext<ChangesContextType>({
    hasChanges: false,
    setHasChanges: () => {},
});

export type AdminUsersState = {
    adminUserNames: Map<number, string>;
    loaded: boolean;
};

export type AdminUsersContextType = AdminUsersState & {
    setAdminUsers: React.Dispatch<React.SetStateAction<AdminUsersState>>;
    refreshAdminUsers: () => void;
};

export const AdminUsersContext = createContext<AdminUsersContextType>({
    adminUserNames: new Map(),
    loaded: false,
    setAdminUsers: () => {},
    refreshAdminUsers: () => {},
});

export type ToastSetter = (toast: any) => void;

let toastSetter: ToastSetter | null = null;

export const setToastHandler = (setter: ToastSetter) => {
    toastSetter = setter;
};

export const showToast = (toast: any) => {
    toastSetter?.(toast);
};